import DashboardInicial from '@/spa/dashboard/DashboardInicial';

export default {
  path: 'dashboard-inicial',
  name: 'dashboard-inicial',
  component: DashboardInicial,
};
